export default "__VITE_ASSET__C2QUK15c__"